import { Skeleton } from "@mui/material";

interface Props {}

export default function LoginPageSkeletonUI(props: Props) {
	return (
		<div className="login-page-container">
			<Skeleton variant="rounded" height={"100%"} />
			<div className="login-right-container">
				<div className="login-container">
					<div
						style={{ display: "flex", flexDirection: "column", gap: "10px" }}
					>
						<Skeleton
							variant="rectangular"
							width={"50%"}
							height={35}
							sx={{ borderRadius: "4px" }}
						/>

						<Skeleton
							variant="rectangular"
							width={"100%"}
							height={35}
							sx={{ borderRadius: "4px" }}
						/>

						<Skeleton
							variant="rectangular"
							width={"70%"}
							height={20}
							sx={{ borderRadius: "4px" }}
						/>
					</div>

					<div>
						<div style={{ padding: "5px 16px" }}>
							<Skeleton
								variant="rectangular"
								width={50}
								height={20}
								sx={{ borderRadius: "4px" }}
							/>
						</div>
						<Skeleton
							variant="rounded"
							width={"100%"}
							height={45}
							sx={{ borderRadius: "4px" }}
						/>
					</div>
					<div>
						<div style={{ padding: "5px 16px" }}>
							<Skeleton
								variant="rectangular"
								width={50}
								height={20}
								sx={{ borderRadius: "4px" }}
							/>
						</div>
						<Skeleton
							variant="rounded"
							width={"100%"}
							height={45}
							sx={{ borderRadius: "4px" }}
						/>
					</div>
					<div className="login-bottom-options-container">
						<div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
							<Skeleton
								variant="rectangular"
								width={120}
								height={20}
								sx={{ borderRadius: "4px" }}
							/>
						</div>
						<div>
							<Skeleton
								variant="rectangular"
								width={110}
								height={20}
								sx={{ borderRadius: "4px" }}
							/>
						</div>
					</div>
					<Skeleton
						variant="rounded"
						width={"100%"}
						height={45}
						sx={{ borderRadius: "30px" }}
					/>
				</div>
				<div className="login-footer" style={{ margin: "auto auto 20px auto" }}>
					{" "}
					<Skeleton
						variant="rectangular"
						width={250}
						height={16}
						sx={{ borderRadius: "4px" }}
					/>
				</div>
			</div>
		</div>
	);
}
